import type { PageSectionLayout } from '../services/sectionLayoutService';
import type { Track } from '../types/domain';

/** 편제 및 기준 시수 섹션에 클래스(grade)가 연결되어 있는지 */
export function isGradeSubscribedToGradeTrackSection(
  sections: PageSectionLayout[],
  gradeId: string
): boolean {
  const gid = gradeId.trim();
  if (!gid) return false;
  return sections.some((s) => s.gradeIds.includes(gid));
}

/** 연결된 섹션의 trackColumns·저장 편제명 집합 */
export function collectSubscribedTrackNamesForGrade(
  sections: PageSectionLayout[],
  gradeId: string
): Set<string> {
  const names = new Set<string>();
  const gid = gradeId.trim();
  if (!gid) return names;
  for (const section of sections) {
    if (!section.gradeIds.includes(gid)) continue;
    for (const col of section.trackColumns ?? []) {
      const n = (col.name ?? '').trim();
      if (n) names.add(n);
    }
  }
  return names;
}

/**
 * 프로그램 메뉴(고정·프로젝트·편제별): 선택 클래스가 구독 중인 편제 섹션의 트랙만 반환.
 * 클래스 미연결 섹션의 편제(또는 DB 잔여 트랙)는 제외한다.
 */
export function filterTracksSubscribedToGradeTrackSections(
  sections: PageSectionLayout[],
  gradeId: string,
  allTracks: Track[]
): Track[] {
  const gid = gradeId.trim();
  if (!gid) return [];
  const gradeTracks = allTracks.filter((t) => (t.grade_id ?? '').trim() === gid);
  // 섹션 구독 정보가 비어 있거나 아직 로드되지 않은 경우에도 기존 편제는 표시한다.
  if (!isGradeSubscribedToGradeTrackSection(sections, gid)) return gradeTracks;

  const subscribedNames = collectSubscribedTrackNamesForGrade(sections, gid);

  if (subscribedNames.size > 0) {
    return gradeTracks.filter((t) => subscribedNames.has((t.name ?? '').trim()));
  }

  return gradeTracks;
}
